import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { fetchUserAttributes } from "@aws-amplify/auth";
import { persistAuthType } from "../../auth/authTypeStorage";
import { resolveSessionForType } from "../../auth/resolveSession";

export default function ProtectedRoute({ children, portalType = "author" }) {
  const [loading, setLoading] = useState(true);
  const [routeState, setRouteState] = useState({
    isLoggedIn: false,
  });
  const location = useLocation();

  const loginRoute = portalType === "reader" ? "/loginreader" : "/loginauthor";
  const returnTo = `${location.pathname}${location.search}${location.hash}`;
  const redirectTo = returnTo
    ? `${loginRoute}?returnTo=${encodeURIComponent(returnTo)}`
    : loginRoute;

  useEffect(() => {
    let isAlive = true;

    (async () => {
      console.info("[ProtectedRoute] auth check start", { portalType, path: returnTo });
      try {
        const session = await resolveSessionForType(portalType, { persist: false, read: portalType === "author" ? fetchUserAttributes : undefined });
        console.info("[ProtectedRoute] session resolved", { portalType, sessionType: session?.type, hasUser: Boolean(session?.user) });
        if (!session) throw new Error("No active session");

        persistAuthType(session.type);


        if (portalType === "author") {
          const attrs = session.data;
          const hasAuthorProfile = Boolean(
            (attrs["custom:firstname"] || "").trim() || (attrs["custom:lastname"] || "").trim()
          );

          if (!hasAuthorProfile) {
            throw new Error("Missing author profile");
          }
        }

        if (isAlive) {
          console.info("[ProtectedRoute] allowing access", { portalType, isLoggedIn: true });
          setRouteState({ isLoggedIn: true });
        }
      } catch (error) {
        console.warn("[ProtectedRoute] auth check failed", { portalType, reason: error?.message || "unknown" });
        if (isAlive) {
          console.info("[ProtectedRoute] forcing logged-out state", { portalType });
          setRouteState({ isLoggedIn: false });
        }
      } finally {
        if (isAlive) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isAlive = false;
    };
  }, [portalType]);

  if (loading) return null;

  if (!routeState.isLoggedIn) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}
